module.exports = __webpack_public_path__ + "static/tabs-2024-803e3d1f8943c6553ff5d1cfdd26bee1.mp4";